export const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (!element) return;

  // Lenis (ak beží) — plynulý scroll bez konfliktu s natívnym smooth
  if (window.__lenis) {
    window.__lenis.scrollTo(element, { offset: -100 });
    return;
  }

  const headerOffset = 100;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
